export const JWT_TOKEN_KEY_NAME = '@tmr-njf_user-token'
export const REDUX_PERSIST_STORE = '@tmr-njf_redux_persist'
export const PROMOTER_STAYING_TIME_DATA = '@tmr-njf_promoters_staying_time_data'
export const PENDING_UPLOADS = '@tmr-njf_pending_uploads'
